export default {
  "back": "返回",
  "pageTitle": "嘉實多汽車膜報價",
  "subtitleFlow": "即選即算",
  "loading": "正在加載報價數據…",
  "reload": "重新加載",
  "loadFailed": "數據加載失敗",
  "completeStepFirst": "請先完成當前步驟",
  "steps": {
    "brand": "1. 選品牌",
    "product": "2. 選產品",
    "parts": "3. 選部位",
    "quote": "4. 看報價"
  },
  "stepMeta": {
    "brand": {
      "title": "選品牌",
      "desc": "車型"
    },
    "product": {
      "title": "選產品",
      "desc": "車衣型號"
    },
    "parts": {
      "title": "選部位",
      "desc": "裝貼範圍"
    },
    "quote": {
      "title": "看報價",
      "desc": "參考價格"
    }
  },
  "selectBrand": "選擇品牌",
  "selectedBrand": "已選品牌",
  "changeBrand": "更換",
  "modelSection": "{brand} · 車型",
  "searchModel": "搜索車型",
  "modelBrowseHint": "搜索或瀏覽該品牌旗下車型",
  "noModels": "暫無車型數據",
  "noModelsQuery": "未找到「{query}」相關車型",
  "bodyTypeDetected": "已識別車身類型：{type}",
  "selectProduct": "選擇產品",
  "fullInstallRef": "整車裝貼參考價",
  "selectParts": "選擇裝貼部位",
  "selectPartsHint": "勾選需要裝貼的車身部位，支持多選",
  "partsSelected": "已選 {count} 個裝貼部位",
  "partsList": "部位清單",
  "selectAll": "全選",
  "deselectAll": "取消全選",
  "partialQuote": "局部貼膜參考報價",
  "disclaimer": "僅供參考，非合同價",
  "vehicleInfo": "車輛信息",
  "brandModel": "品牌車型",
  "bodyType": "車身類型",
  "productCode": "產品型號",
  "installParts": "裝貼部位",
  "prev": "上一步",
  "next": "下一步",
  "viewQuote": "查看報價",
  "restart": "重新報價",
  "adjustParts": "調整部位",
  "searchBrand": "搜索品牌，如 大眾、寶馬",
  "brandBrowseHint": "按拼音首字母瀏覽，支持搜索新能源品牌",
  "noBrands": "未找到「{query}」相關品牌",
  "bodyTypes": {
    "轿车": "轎車",
    "SUV": "SUV",
    "跑车": "跑車",
    "MPV": "MPV"
  },
  "productTier": {
    "flagship": "旗艦",
    "premium": "高端",
    "quality": "品質",
    "bestseller": "暢銷",
    "balanced": "均衡",
    "entry": "入門",
    "default": "車衣"
  },
  "productNames": {
    "T9": "統御(T9-1501)漆面保護膜",
    "A8": "昂御(A8-1401)漆面保護膜",
    "E7": "雅御(E7-1301)漆面保護膜",
    "GM7": "佳御(啞光)(GM7-1102)漆面保護膜",
    "GH7": "佳御(亮黑)(GH7-1103)漆面保護膜",
    "R8": "睿御(R8-1201)漆面保護膜",
    "G7": "佳御(G7-1101)漆面保護膜",
    "CC": "雅彩(CC-01-3101)汽車彩繪膜"
  },
  "productCategory": {
    "ppf": "車衣",
    "paint": "彩繪"
  },
  "vehiclePhaseBrand": "選品牌",
  "vehiclePhaseModel": "選車型",
  "vehicleHubTitle": "選擇車輛",
  "vehicleHubDesc": "選擇品牌和車型後，系統將自動識別車身類型",
  "vehicleHubBrandEmpty": "請選擇品牌",
  "vehicleHubModelEmpty": "請先選擇品牌",
  "vehicleHubModelPlaceholder": "請選擇車型",
  "vehiclePickerBack": "返回",
  "vehicleFlowLabel": "車輛選擇流程",
  "vehicleFlowModelHint": "請選擇車型",
  "changeBrandHint": "點擊可更換品牌",
  "livePrice": "參考報價",
  "saveScreenshot": "保存長圖",
  "screenshotSaved": "長圖已保存",
  "screenshotPreviewHint": "長按圖片可保存到相冊",
  "screenshotPreviewTitle": "報價長圖預覽",
  "screenshotPreviewClose": "關閉預覽",
  "screenshotPreviewPrev": "上一張",
  "screenshotPreviewNext": "下一張",
  "screenshotSegmented": "內容較長，已生成 {count} 張圖片，請逐張長按保存",
  "screenshotFailed": "保存失敗，請重試",
  "screenshotTimeout": "生成超時，請稍後重試",
  "capturingScreenshot": "正在生成長圖",
  "capturingScreenshotHint": "正在渲染頁面內容，請稍候…",
  "capturingScreenshotSlice": "正在生成第 {current}/{total} 張…",
  "capturingScreenshotSaving": "即將完成，正在準備預覽…",
  "notSelected": "未選",
  "partSelected": "已選",
  "partsSelectedGroup": "已選（{count}）",
  "partsNotSelectedGroup": "未選（{count}）",
  "allInstallParts": "裝貼部位明細",
  "parts": {
    "引擎盖": "引擎蓋",
    "车顶": "車頂",
    "后尾箱盖": "後尾箱蓋",
    "左后叶子板": "左後葉子板",
    "右后叶子板": "右後葉子板",
    "前左叶子板": "前左葉子板",
    "前右叶子板": "前右葉子板",
    "左后门": "左後門",
    "右后门": "右後門",
    "左前门": "左前門",
    "右前门": "右前門",
    "前杠": "前槓",
    "后杠": "後槓",
    "左侧裙边": "左側裙邊",
    "右侧裙边": "右側裙邊",
    "左后视镜": "左後視鏡",
    "右后视镜": "右後視鏡"
  }
};
